// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { list16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-list': IconList;
    }
}

/**
 * The icon component for the 'list' icon
 */
export class IconList extends IconSvg {
    public constructor() {
        super(list16X16);
    }
}

registerIconSvg('icon-list', IconList);
export const iconListTag = 'nimble-icon-list';
